import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class ReferenciasService {

    // OBTENER TODAS
    getReferencias(context) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            // URL apuntando a WCFReferencias
            apiClientToken.get(store.getters.getUrlServicios + "WCFReferencias.svc/RestService/ObtenerTodas")
                .then(function(response) {
                    
                    var data = controller.getData(context, response);

                    if (data && typeof data === 'string') {
                        try {
                            data = JSON.parse(data);
                        } catch (e) {
                            // Usamos console.error para que resalte si falla, pero no detiene la app
                            console.error("Error crítico parseando JSON en Referencias:", e);
                        }
                    }

                    resolve(data);
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al obtener las referencias",
                        life: 3000
                    });
                    // para ver errores de red (404, 500)
                    console.error(error);
                    reject(error);
                });
        });
    }

    // GUARDAR
    addReferencia(context, parametro) {
        var t = context;
        var controller = new Controller();
        return new Promise(function(resolve, reject) {
            apiClientToken.post(store.getters.getUrlServicios + "WCFReferencias.svc/RestService/Guardar", parametro)
                .then(function(response) {
                    var data = controller.getData(context, response);
                    
                    if (data && typeof data === 'string') {
                         try { 
                             data = JSON.parse(data); 
                         } catch(e) {
                             console.error("Error crítico parseando JSON en Guardar:", e);
                         }
                    }
                    resolve(data);
                })
                .catch(function(error) {
                    t.$toast.add({
                        severity: "error",
                        summary: "ERROR",
                        detail: "Error al guardar la referencia",
                        life: 3000
                    });
                    console.error(error);
                    reject(error);
                });
        });
    }

    // ACTUALIZAR
    updateReferencia(context, parametro) {
        return this.addReferencia(context, parametro);
    }
}